import Navbar from "../components/HomeNew/Navbar";
import HeroSection from "../components/HomeNew/HeroSection";
import StatsSection from "../components/HomeNew/StatsSection";
import WhyTaramSection from "../components/HomeNew/WhyTaramSection";
import WhatWeDoSection from "../components/HomeNew/WhatWeDoSection";
import HowItWorksSection from "../components/HomeNew/HowItWorksSection";
import VerticalsSection from "../components/HomeNew/VerticalsSection";
import AdvantagesSection from "../components/HomeNew/AdvantagesSection";
import TestimonialsSection from "../components/HomeNew/TestimonialsSection";
import ContactSection from "../components/HomeNew/ContactSection";
import Footer from "../components/HomeNew/Footer";

import "../styles/home-new.css";

export default function HomeNew() {
  return (
    <div id="home-new-root" className="min-h-screen bg-background">
      <Navbar />
      <HeroSection />
      <StatsSection />
      <WhyTaramSection />
      <WhatWeDoSection />
      <HowItWorksSection />
      <VerticalsSection />
      <AdvantagesSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
